import { render, staticRenderFns } from "./ServicesFilters.vue?vue&type=template&id=60d3b089&scoped=true"
import script from "./ServicesFilters.vue?vue&type=script&lang=js"
export * from "./ServicesFilters.vue?vue&type=script&lang=js"
import style0 from "./ServicesFilters.vue?vue&type=style&index=0&id=60d3b089&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d3b089",
  null
  
)

export default component.exports